export const userTypes = {
    Fyrirtaeki : 'fyrirtaeki',
    Einstaklingur : 'einstaklingur'
}


// WEBPACK FOOTER //
// ./src/UserTypes.js